import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SearchHighlightPipe } from './search-highlight.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [SearchHighlightPipe],
  exports: [SearchHighlightPipe],
})
export class SearchHighlightPipeModule {}
